/**
 * Data layer for `lead-ping-tree-ping-post-productized-module`. Thin typed fetch wrappers over /api/v1/lead-ping-tree-ping-post-productized-module.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface LeadPingTreePingPostProductizedModuleRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListLeadPingTreePingPostProductizedModuleResponse {
	count: number;
	items: LeadPingTreePingPostProductizedModuleRow[];
}

export interface CreateLeadPingTreePingPostProductizedModuleBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/lead-ping-tree-ping-post-productized-module";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListLeadPingTreePingPostProductizedModuleResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListLeadPingTreePingPostProductizedModuleResponse>(res);
}

export async function create(body: CreateLeadPingTreePingPostProductizedModuleBody): Promise<LeadPingTreePingPostProductizedModuleRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<LeadPingTreePingPostProductizedModuleRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const leadPingTreePingPostProductizedModuleQueryKeys = {
	all: ["lead-ping-tree-ping-post-productized-module"] as const,
	list: () => [...leadPingTreePingPostProductizedModuleQueryKeys.all] as const,
	detail: (id: string) => [...leadPingTreePingPostProductizedModuleQueryKeys.all, id] as const,
};
